module.exports = __webpack_public_path__ + "img/47.7b4e30ae.jpg";